"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchRelatedProductsSuccess = exports.fetchRelatedProducts = exports.fetchProductSuccess = exports.fetchProduct = exports.FETCH_RELATED_PRODUCTS_SUCCESS = exports.FETCH_RELATED_PRODUCTS = exports.FETCH_PRODUCT_SUCCESS = exports.FETCH_PRODUCT = void 0;

var _api = require("@modules/api");

var _snackbar = require("@modules/snackbar");

var _mutator = require("./mutator");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ROOT = '@@product';
var FETCH_PRODUCT = "".concat(ROOT, "/FETCH_PRODUCT");
exports.FETCH_PRODUCT = FETCH_PRODUCT;
var FETCH_PRODUCT_SUCCESS = "".concat(ROOT, "/FETCH_PRODUCT_SUCCESS");
exports.FETCH_PRODUCT_SUCCESS = FETCH_PRODUCT_SUCCESS;
var FETCH_RELATED_PRODUCTS = "".concat(ROOT, "/FETCH_RELATED_PRODUCTS");
exports.FETCH_RELATED_PRODUCTS = FETCH_RELATED_PRODUCTS;
var FETCH_RELATED_PRODUCTS_SUCCESS = "".concat(ROOT, "/FETCH_RELATED_PRODUCTS_SUCCESS");
exports.FETCH_RELATED_PRODUCTS_SUCCESS = FETCH_RELATED_PRODUCTS_SUCCESS;

var fetchProduct = function fetchProduct(productID) {
  var _next;

  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_PRODUCT,
    route: "/products/".concat(productID),
    schema: _mutator.transformProduct,
    next: (_next = {}, _defineProperty(_next, _api.apiActions.CALL_API_SUCCESS, fetchProductSuccess), _defineProperty(_next, _api.apiActions.CALL_API_FAIL, function (_ref) {
      var error = _ref.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next)
  };
};

exports.fetchProduct = fetchProduct;

var fetchProductSuccess = function fetchProductSuccess(product) {
  return {
    type: FETCH_PRODUCT_SUCCESS,
    product: product
  };
};

exports.fetchProductSuccess = fetchProductSuccess;

var fetchRelatedProducts = function fetchRelatedProducts(productID) {
  var _next2;

  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_RELATED_PRODUCTS,
    route: "/products/".concat(productID, "/related"),
    schema: _mutator.transformRelatedProducts,
    next: (_next2 = {}, _defineProperty(_next2, _api.apiActions.CALL_API_SUCCESS, fetchRelatedProductsSuccess), _defineProperty(_next2, _api.apiActions.CALL_API_FAIL, function (_ref2) {
      var error = _ref2.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next2)
  };
};

exports.fetchRelatedProducts = fetchRelatedProducts;

var fetchRelatedProductsSuccess = function fetchRelatedProductsSuccess(products) {
  return {
    type: FETCH_RELATED_PRODUCTS_SUCCESS,
    products: products
  };
};

exports.fetchRelatedProductsSuccess = fetchRelatedProductsSuccess;